import { formPostApi, mutateApi, queryApi } from "src/utils/api/ApiMethods"

export const submitContract = ({ quoteId, formData }) => {
  return formPostApi({
    url: `/contract_quotes/${quoteId}/submit`,
    data: formData,
  })
}

export const validateDocument = ({ quoteId, file, documentType }) => {
  const data = new FormData()
  data.append("document", file)
  data.append("document_type", documentType)
  return formPostApi({
    url: `/contract_quotes/${quoteId}/validate_document`,
    data,
  }).catch((error) => {
    if (error?.status === 403) {
      return { valid: false, code: "forbidden" }
    }
    throw error
  })
}

export const declineContract = ({ quoteId }) => {
  return mutateApi({
    url: `/contract_quotes/${quoteId}/decline`,
    method: "POST",
    data: {},
  })
}

export const updateHomeport = ({ quoteId, data }) => {
  return mutateApi({
    url: `/contract_quotes/${quoteId}/update_homeport`,
    method: "PATCH",
    data,
  })
}

export const homeportPrompt = ({ quoteId }) => {
  return queryApi(`/contract_quotes/${quoteId}/homeport_prompt`)
}

export const reviewAgreement = ({ quoteId, paymentMethodId }) => {
  return queryApi(
    `/contract_quotes/${quoteId}/review?payment_method_id=${encodeURIComponent(
      paymentMethodId ?? ""
    )}`
  )
}

export const recordStepReached = ({ quoteId, index, total, label }) => {
  return mutateApi({
    url: `/contract_quotes/${quoteId}/step`,
    method: "POST",
    data: { index, total, label },
  })
}
